import {Component, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-exg-input-v2',
  templateUrl: './exg-input-v2.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR, useExisting: ExgInputV2Component, multi: true
  }]
})
export class ExgInputV2Component implements ControlValueAccessor {

  @Input() type = 'text';
  @Input() caption = '';
  @Input() disabled!: string;
  @Input() required = false;
  @Input() pattern = '';
  @Input() min: any = 0;
  @Input() max: any = 2048;
  @Input() minlength = 0;
  @Input() maxlength = 2048;
  @Input() step = 1.0;
  @Input() hintText = '';
  @Input() isEpoch = false;

  // isEpoch ist ein Fix für die input type = date, datetime-local damit man einfach Epoch Werte eigehend, ausgehend binden kann
  // Warum das so ist kann man in der bekloppten HTML Dokumentation nachlesen

  _value: any = null;
  get value(): any {
    return this._value;
  }

  set value(obj: any) {
    this.onChange(!this.isEpoch ? obj : Date.parse(obj));
    this.onTouched(!this.isEpoch ? obj : Date.parse(obj));
    this._value = obj;
  }

  onChange: any = () => {
  }
  onTouched: any = () => {
  }

  constructor() {
  }

  // ControlValueAccessor -> OUT
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // ControlValueAccessor <- IN
  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    // Epoch Daten auf Locale Zeit füre das Input Element formatieren
    if (this.type === 'datetime-local' || this.type === 'date') {
      if (!this.isEpoch || obj === null || obj === undefined) {
        this._value = obj;
      } else {
        // Timezone Correction
        const tc = new Date(obj).setMinutes(new Date(obj).getMinutes() - new Date(obj).getTimezoneOffset());
        this._value = new Date(tc).toISOString().slice(0, this.type === 'date' ? 10 : 19);
      }
    } else {
      this._value = obj;
    }
  }
  // ---------------

}

